module.exports = __WEBPACK_EXTERNAL_MODULE_57__;


/*****************
 ** WEBPACK FOOTER
 ** external "angular"
 ** module id = 57
 ** module chunks = 0 1 2 3
 **/